import { render, staticRenderFns } from "./FigmaSelectFrames.vue?vue&type=template&id=7db337a4&scoped=true&"
import script from "./FigmaSelectFrames.vue?vue&type=script&lang=js&"
export * from "./FigmaSelectFrames.vue?vue&type=script&lang=js&"
import style0 from "./FigmaSelectFrames.vue?vue&type=style&index=0&id=7db337a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db337a4",
  null
  
)

export default component.exports